import React from 'react';
import { Image, Text, View } from 'react-native';
import { Android, kbd_come_back_icon, Onboarding_example } from '../../../../utils/DictionaryManagementUtils';
import {
  getImageByKey,
  img_kbd,
  img_scr_onboarding_03_a_ios,
  img_settings,
  img_switch,
} from '../../../../utils/ImagesManagementUtils';
import { getRef, LocStr, xlateText } from '../../../../utils/Utils';
import BigIconWithTextLine from '../../AuxiliaryComponent/MixComponent/BigIconWithTextLine';
import LongLine from '../../AuxiliaryComponent/MixComponent/LongLine';
import IconNearParagraph from '../../AuxiliaryComponent/MixComponent/IconNearParagraph';
import LargeBtnWithFilling from '../../AuxiliaryComponent/ButtonComponent/LargeBtnWithFilling';
import OnBoardingTopTitlesIOS from '../../AuxiliaryComponent/MixComponent/OnBoardingTopTitlesIOS';
import { textPrimary_9_2 } from '../../AuxiliaryComponent/TextComponent/TextStyle';
//= ========================================================================
const EnableKeyboardIosFP = ({
  globJSON,
  language,
  simPlatform,
  withoutTitle,
  slideshowRefs,
}) => {
  const { colors } = globJSON.configurations.theme;
  const { instructions } = globJSON.configurations.onboarding;

  const img1 = getImageByKey(globJSON.configurations.onboarding.instructions.kbd_come_back_icon, kbd_come_back_icon);

  // TODO remove send_money_0 as constant
  const myStyles = {
    phoneImage: {
      width: 240,
      height: simPlatform === Android ? 427 : 520,
      marginTop: !withoutTitle && 20,
      position: 'absolute',
      backgroundColor: simPlatform === Android
        ? '#f0f5f9'
        : colors.app_background_color,
    },
    lblPhoneTitle: {
      width: 240,
      height: 20,
      fontFamily: 'Quicksand-SemiBold',
      fontSize: 16,
      color: colors.primary_font_color,
      position: 'absolute',
    },
    lblBottomLine: {
      width: 86,
      marginTop: 20,
      height: 3.2,
      alignSelf: 'center',
      borderRadius: 1.6,
      backgroundColor: colors.primary_font_color,
    },
    spaceLine: {
      paddingVertical: 10,
      marginTop: 75,
    },
    GrayDisplay: {
      width: 240,
      height: 520,
      marginTop: 30,
      marginLeft: 0,
      position: 'absolute',
      backgroundColor: '#fff',
      opacity: 0.5,
    },
  };

  return (
    <View ref={getRef(slideshowRefs)}>
      {!withoutTitle
            && (
            <Text
              style={[myStyles.lblPhoneTitle, { opacity: globJSON.configurations.onboarding.announcement.enable_keyboard_activation_flow ? 1.0 : 0.5 }]}
            >
              {LocStr(Onboarding_example, language)}
            </Text>
            )}
      <Image
        fadeDuration={0}
        style={myStyles.phoneImage}
        source={img_scr_onboarding_03_a_ios}
      />
      <View>
        <OnBoardingTopTitlesIOS
          globJSON={globJSON}
          simPlatform={simPlatform}
          subTitle={instructions.o_i_step_1_of_2}
          Title={xlateText(instructions.o_i_enable_bank_keyboard, globJSON)}
          withoutExtraHeight={!withoutTitle}
        />

        <View style={{ paddingStart: 19, paddingEnd: 5, marginTop: 20 }}>
          <BigIconWithTextLine
            globJSON={globJSON}
            simPlatform={simPlatform}
            icon={img_settings}
            txt={xlateText(instructions.o_i_goto_settings, globJSON)}
          />
          <BigIconWithTextLine
            globJSON={globJSON}
            simPlatform={simPlatform}
            icon={img_kbd}
            txt={xlateText(instructions.o_i_tap_keyboards, globJSON)}
          />
          <BigIconWithTextLine
            globJSON={globJSON}
            simPlatform={simPlatform}
            icon={img_switch}
            txt={xlateText(instructions.o_i_enable_keyboard, globJSON)}
          />
          <BigIconWithTextLine
            globJSON={globJSON}
            simPlatform={simPlatform}
            icon={img1}
            txt={xlateText(instructions.o_i_come_back_here, globJSON)}
          />

          <LongLine globJSON={globJSON} width={202} />
          <View style={{ marginTop: 25 }}>
            <IconNearParagraph
              globJSON={globJSON}
              simPlatform={simPlatform}
            />
          </View>
        </View>
        <View style={myStyles.spaceLine}>
          <LargeBtnWithFilling
            globJSON={globJSON}
            simPlatform={simPlatform}
            inputText={instructions.o_i_take_me_there}
          />
        </View>
        <Text style={[textPrimary_9_2(globJSON, simPlatform), { alignSelf: 'center' }]}>
          {instructions.o_i_nanother_time}
        </Text>

        <View style={myStyles.lblBottomLine} />
      </View>
      {instructions.enable_keyboard_activation_flow && (
        <View style={myStyles.GrayDisplay} />
      )}
    </View>

  );
};

export default EnableKeyboardIosFP;
